import React, {useEffect, useState} from "react";
import EnterpriseComponent from "../../../ec/EnterpriseComponent";
import {Accordion, AccordionDetails, AccordionSummary, Button, FormControlLabel, FormGroup, IconButton, Switch, Typography} from "@mui/material";
import moment from "moment-timezone";
import {Cancel, CheckCircle, CloudDone, ExpandMore, Refresh, Report} from "@mui/icons-material";
import {Blue3, Green3, Grey5, Grey6, Red3} from "../../../../theme/styles";
import css_buttons from "../../../../components/Common/css/CCButton.module.scss";
import css_typography from "../../../../components/Common/css/Typography.module.scss";
import {formatLocal, formatLocalTime, ISO_8601} from "../../../../util/Formatters";
import css_pages from "../../../../../src/pages/css/Pages.module.scss";
import {prepareBuffer} from "../../../../util/Buffer";

export default function ETLJobExecutionDetailApplet(props: any) {
    const [refreshDatetime, setRefreshDatetime] = useState<any>(moment.now());
    const [autoRefresh, setAutoRefresh] = useState<boolean>(true);
    const [timeoutID, setTimeoutID] = useState<number>(-1);
    const [viewOption, setViewOption] = React.useState<string | null>("Pre-Execution Logs");
    const [etlJobPreExecutionLogBuffer, setETLJobPreExecutionLogBuffer] = React.useState<Array<any>>([]);
    const [etlJobExecutionLogBuffer, setETLJobExecutionLogBuffer] = React.useState<Array<any>>([]);
    const [etlJobSystemExecutionLogBuffer, setETLJobSystemExecutionLogBuffer] = React.useState<Map<string, any>>(new Map<string, any>());

    function enterpriseComponentRecordChangedListener(ec: EnterpriseComponent) {
    }

    function enterpriseComponentInvalidedListener(ec: EnterpriseComponent) {
        ec.newQuery();
        ec.executeQuery(1, 500);
    }

    function enterpriseComponentLoadStartedListener(ec: EnterpriseComponent) {
    }

    function enterpriseComponentLoadCompletedListener(ec: EnterpriseComponent) {
        if (ec.serialNumber === props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJobPreExecutionLog").serialNumber) {
            let b: Map<string, any>[] = prepareBuffer(ec)
            let buffer: Map<string, any[]> = new Map<string, any[]>();
            for (let i = 0; i < b.length; i++) {
                if (b[i].get("LogJSON") !== undefined) {
                    if (buffer.get(b[i].get("LogJSON")["DocumentId"]) === undefined) {
                        buffer.set(b[i].get("LogJSON")["DocumentId"], []);
                    }
                    buffer.get(b[i].get("LogJSON")["DocumentId"])!.push(b[i]);
                }
            }
            setETLJobPreExecutionLogBuffer(Array.from(buffer, ([key, value]) => ({key, value})));
        } else if (ec.serialNumber === props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJobExecutionLog").serialNumber) {
            let b: Map<string, any>[] = prepareBuffer(ec)
            setETLJobExecutionLogBuffer(b);
        } else {
            let b:Map<string, any>[] = prepareBuffer(ec)
            setETLJobSystemExecutionLogBuffer(b[0]);
        }
    }

    function refresh() {
        props.enterpriseComponent.executeSingleRecordRefresh();

        setRefreshDatetime(moment.now())

        if (autoRefresh) {
            // @ts-ignore
            setTimeoutID(setTimeout(refresh, 60 * 1000))
        } else {
            clearTimeout(timeoutID);
        }
    }

    useEffect(() => {
        const etlJobPreExecutionLogEnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJobPreExecutionLog");
        const etlJobExecutionLogEnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJobExecutionLog");
        const etlJobSystemExecutionLogEnterpriseComponent = props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJobSystemExecutionLog");

        etlJobPreExecutionLogEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidedListener);
        etlJobPreExecutionLogEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        etlJobPreExecutionLogEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        etlJobExecutionLogEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidedListener);
        etlJobExecutionLogEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        etlJobExecutionLogEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        etlJobSystemExecutionLogEnterpriseComponent.addInvalidListener(enterpriseComponentInvalidedListener);
        etlJobSystemExecutionLogEnterpriseComponent.addLoadStartedListener(enterpriseComponentLoadStartedListener);
        etlJobSystemExecutionLogEnterpriseComponent.addLoadCompletedListener(enterpriseComponentLoadCompletedListener);

        // @ts-ignore
        setTimeoutID(setTimeout(refresh, 60 * 1000))

        return () => {
            etlJobPreExecutionLogEnterpriseComponent.removeInvalidListener(enterpriseComponentInvalidedListener);
            etlJobPreExecutionLogEnterpriseComponent.removeLoadStartedListener(enterpriseComponentRecordChangedListener);
            etlJobPreExecutionLogEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);

            etlJobExecutionLogEnterpriseComponent.removeInvalidListener(enterpriseComponentInvalidedListener);
            etlJobExecutionLogEnterpriseComponent.removeLoadStartedListener(enterpriseComponentRecordChangedListener);
            etlJobExecutionLogEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);

            etlJobSystemExecutionLogEnterpriseComponent.removeInvalidListener(enterpriseComponentInvalidedListener);
            etlJobSystemExecutionLogEnterpriseComponent.removeLoadStartedListener(enterpriseComponentRecordChangedListener);
            etlJobSystemExecutionLogEnterpriseComponent.removeLoadCompletedListener(enterpriseComponentLoadCompletedListener);
        }

    }, [props.enterpriseComponent]);

    function formatLastEdit() {
        let datetime = props.enterpriseComponent.getAttributeValue("LastModifiedDatetime")

        let now = moment().utc()
        let diffInMinutes = now.diff(datetime, "minutes")
        let diffInHours = now.diff(datetime, "hours")
        let diffInDays = now.diff(datetime, "days")
        let diffInYears = now.diff(datetime, "days")

        if (datetime === undefined) {
            // do nothing
        } else if (diffInMinutes === 0) {
            return `Just now`
        } else if (diffInMinutes < 60) {
            if (diffInMinutes === 1) {
                return `${diffInMinutes} minute ago`;
            } else {
                return `${diffInMinutes} minutes ago`;
            }
        } else if (diffInMinutes > 60 && diffInMinutes < 1440) {
            if (diffInHours === 1) {
                return `${diffInHours} hour ago`;
            } else {
                return `${diffInHours} hours ago`;
            }
        } else if (diffInMinutes > 1440 && diffInMinutes < 525949) {
            if (diffInDays === 1) {
                return `${diffInDays} day ago`;
            } else {
                return `${diffInDays} days ago`;
            }
        } else if (diffInMinutes > 525949) {
            if (diffInYears === 1) {
                return `${diffInYears} year ago`;
            } else {
                return `${diffInYears} years ago`;
            }
        }
        return "";
    }

    function calculate_success(element: any) {
        let accumulator = 0;
        for (let i = 0; i < element.value.length; i++) {
            if (element.value[i].get("LogJSON").Status === "SUCCESS") {
                accumulator += 1;
            }
        }
        return accumulator;
    }

     function calculate_failure(element: any) {
        let accumulator = 0;
        for (let i = 0; i < element.value.length; i++) {
            if (element.value[i].get("LogJSON").Status === "FAILURE") {
                accumulator += 1;
            }
        }
        return accumulator;
    }

    return (
        <>
            <div style={{display: "flex", flexDirection: "column"}}>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", height: "40px"}}>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginTop: "8px"}}>
                        <Typography style={{fontSize: "24px", fontWeight: 500, color: "#000000", minWidth: "470px"}}>{props.enterpriseComponent.getAttributeValue("USID")}</Typography>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", marginLeft: "15px", marginTop: "-12px"}}>
                            <FormGroup>
                                <FormControlLabel style={{whiteSpace: "nowrap"}} control={<Switch checked={autoRefresh} defaultChecked onChange={() => {
                                    setAutoRefresh(!autoRefresh);
                                    if (!autoRefresh) {
                                        // @ts-ignore
                                        setTimeoutID(setTimeout(refresh, 60 * 1000))
                                    } else {
                                        clearTimeout(timeoutID);
                                    }
                                }}/>} label="Auto-refresh" />
                            </FormGroup>
                        </div>
                    </div>
                    <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", paddingTop: "8px"}}>
                        <CloudDone sx={{color: Blue3, width: "20px", height: "20px", marginTop: "8px", marginRight: "10px"}}/>
                        <div style={{marginRight: "10px"}}>
                            <Typography style={{margin: "8px 0 0 0", fontSize: "14px", fontWeight: 400, color: Grey6}}>Execution last refreshed: {formatLocalTime(refreshDatetime)}. {autoRefresh ? "Auto-refreshes every 60 seconds." : null} </Typography>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-end", marginLeft: "10px"}}>
                            <IconButton className={css_buttons.blueOutlinedButton} style={{border: "1px solid #1498D8", padding: "0 5px 0 5px", width: "35px", height: "35px"}} onClick={() => {refresh()}}>
                                <Refresh />
                            </IconButton>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", marginLeft: "10px"}}>
                            <Button
                                className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} disabled={props.enterpriseComponent.getAttributeValue("Status") !== "SUBMITTED" && props.enterpriseComponent.getAttributeValue("Status") !== "PENDING" && props.enterpriseComponent.getAttributeValue("Status") !== "RUNNABLE"} size="small"
                                onClick={() => {}}
                                startIcon={<Cancel sx={{color: "#FFFFFF", width: "25px", height: "25px"}}/>}>
                                Cancel
                            </Button>
                        </div>
                        <div style={{display: "flex", flexDirection: "row", marginLeft: "10px"}}>
                            <Button
                                className={css_buttons.blueStandardButton} style={{cursor: "pointer", height: "35px", padding: "0 15px 0 15px"}} size="small" disabled={props.enterpriseComponent.getAttributeValue("Status") !== "STARTING" && props.enterpriseComponent.getAttributeValue("Status") !== "RUNNING"}
                                onClick={() => {}}
                                startIcon={<Report sx={{color: "#FFFFFF", width: "25px", height: "25px"}}/>}>
                                Terminate
                            </Button>
                        </div>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "150px", paddingTop: "20px", paddingBottom: "20px", marginTop: "15px", backgroundColor: "#FFFFFF", border: "1px solid #EDEFF3", borderRadius: "20px"}}>
                    <div style={{width: "25%", borderRight: "1px solid #D8DDE4"}}>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "10px", marginLeft: "20px"}}>Status</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{props.enterpriseComponent.getAttributeValue("Status")}</Typography>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "30px", marginLeft: "20px"}}>Created At</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{formatLocal(props.enterpriseComponent.getAttributeValue("CreatedDatetime"))}</Typography>
                    </div>
                    <div style={{width: "25%", borderRight: "1px solid #D8DDE4"}}>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "10px", marginLeft: "20px"}}>Status Reason</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{props.enterpriseComponent.getAttributeValue("StatusReason")}</Typography>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "30px", marginLeft: "20px"}}>Started At</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{formatLocal(props.enterpriseComponent.getAttributeValue("StartedDatetime"))}</Typography>
                    </div>
                    <div style={{width: "25%", borderRight: "1px solid #D8DDE4"}}>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "10px", marginLeft: "20px", height: "45px"}}></Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}></Typography>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "30px", marginLeft: "20px"}}>Stopped At</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{formatLocal(props.enterpriseComponent.getAttributeValue("StoppedDatetime"))}</Typography>
                    </div>
                    <div style={{width: "25%"}}>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "10px", marginLeft: "20px"}}>Job USID</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{props.enterpriseComponent.getEnterpriseObject().getEnterpriseComponent("ETLJob").getAttributeValue("USID")}</Typography>
                        <Typography className={css_typography.DetailLabel} style={{fontSize: "16px", fontWeight: 600, marginTop: "30px", marginLeft: "20px"}}>Job Execution USID</Typography>
                        <Typography className={css_typography.DetailData} style={{fontSize: "16px", fontWeight: 400, marginLeft: "20px"}}>{props.enterpriseComponent.getAttributeValue("USID")}</Typography>
                    </div>
                </div>
                <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", height: "40px", marginTop: "10px"}}>
                    <div style={viewOption === "Pre-Execution Logs" ? {paddingBottom: "4px", borderBottom: "2px solid #525968"} : {borderBottom: "0px solid #525968"}}>
                        <Button className={css_pages.NavMenuButton} variant="text" onClick={() => {
                            setViewOption("Pre-Execution Logs")
                        }}>Pre-Execution Logs</Button>
                    </div>
                    <div style={viewOption === "Enlil Execution Logs" ? {paddingBottom: "4px", borderBottom: "2px solid #525968", marginLeft: "20px"} : {borderBottom: "0px solid #525968", marginLeft: "20px"}}>
                        <Button className={css_pages.NavMenuButton} variant="text" onClick={() => {
                            setViewOption("Enlil Execution Logs")
                        }}>Enlil Execution Logs</Button>
                    </div>
                    <div style={viewOption === "System Execution Logs" ? {paddingBottom: "4px", borderBottom: "2px solid #525968", marginLeft: "20px"} : {borderBottom: "0px solid #525968", marginLeft: "20px"}}>
                        <Button className={css_pages.NavMenuButton} variant="text" onClick={() => {
                            setViewOption("System Execution Logs")
                        }}>System Execution Logs</Button>
                    </div>
                </div>
                {viewOption === "Pre-Execution Logs" ? (
                    <>
                        <div style={{display: "flex", flexDirection: "column", paddingTop: "20px", padding: "20px 20px 20px 20px", marginTop: "15px", backgroundColor: "#FFFFFF", border: "1px solid #EDEFF3", borderRadius: "20px"}}>
                            {etlJobPreExecutionLogBuffer.map((element: any, index: number) => (
                                <Accordion key={index} style={{backgroundColor: "#FFFFFF"}}>
                                    <AccordionSummary expandIcon={<ExpandMore/>}>
                                        <div style={{display: "flex", flexDirection: "row", justifyContent: "flex-start", width: "100%"}}>
                                            <Typography style={{paddingTop: "3px"}}><b>{element.key}</b></Typography>
                                            <div style={{display: "flex", flexDirection: "row", marginLeft: "50px"}}>
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px"}}><b>{element.value.length}</b></Typography>
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px", color: Grey5}}> Total tests</Typography>
                                            </div>
                                            <div style={{display: "flex", flexDirection: "row", marginLeft: "50px"}}>
                                                <CheckCircle sx={{color: Green3, width: "25px", height: "25px", margin: "auto 0 auto 0"}}/>
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px"}}><b>{calculate_success(element)}</b></Typography>
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px", color: Grey5}}> Succeeded</Typography>
                                            </div>
                                            <div style={{display: "flex", flexDirection: "row", marginLeft: "50px"}}>
                                                <Cancel sx={{color: Red3, width: "25px", height: "25px", margin: "auto 0 auto 0"}} />
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px"}}><b>{calculate_failure(element)}</b></Typography>
                                                <Typography style={{fontSize: "14px", margin: "auto 0 auto 5px", color: Grey5}}> Failed</Typography>
                                            </div>
                                        </div>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <div key={index} style={{display: "flex", flexDirection: "column"}}>
                                            <div key={index} style={{display: "flex", flexDirection: "row"}}>
                                                <div style={{width: "100px", borderRight: "1px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Status</b></div>
                                                <div style={{width: "150px", borderRight: "1px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Rule</b></div>
                                                <div style={{width: "150px", borderRight: "1px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Item</b></div>
                                                <div style={{width: "150px", borderRight: "1px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Value</b></div>
                                                <div style={{width: "450px", borderRight: "1px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Description</b></div>
                                                <div style={{width: "450px", borderRight: "0px solid #BAC3CE", borderTop: "1px solid #BAC3CE", borderBottom: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><b>Remedy/Conclusion</b></div>
                                            </div>
                                            {element.value.map((row: any, index: number) => (
                                                <div key={index} style={{display: "flex", flexDirection: "row", borderBottom: "1px solid #BAC3CE"}}>
                                                    <div style={{width: "100px", borderRight: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px", color: row.get("LogJSON").Status === "SUCCESS" ? Green3 : Red3}}>{row.get("LogJSON").Status}</Typography></div>
                                                    <div style={{width: "150px", borderRight: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px"}}>{row.get("LogJSON").Rule}</Typography></div>
                                                    <div style={{width: "150px", borderRight: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px"}}>{row.get("LogJSON").FieldName}</Typography></div>
                                                    <div style={{width: "150px", borderRight: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px"}}>{row.get("LogJSON").Value}</Typography></div>
                                                    <div style={{width: "450px", borderRight: "1px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px"}}>{row.get("LogJSON").Description}</Typography></div>
                                                    <div style={{width: "450px", borderRight: "0px solid #BAC3CE", padding: "2px 0 2px 3px"}}><Typography style={{fontSize: "12px"}}>{row.get("LogJSON").Remedy}</Typography></div>
                                                </div>
                                            ))}
                                        </div>
                                    </AccordionDetails>
                                </Accordion>
                            ))}
                        </div>
                    </>
                ) : null}
                {viewOption === "Enlil Execution Logs" ? (
                    <>
                        <div style={{display: "flex", flexDirection: "column", paddingTop: "20px", padding: "20px 20px 20px 20px", marginTop: "15px", backgroundColor: "#FFFFFF", border: "1px solid #EDEFF3", borderRadius: "20px"}}>
                            {etlJobExecutionLogBuffer.map((element: any, index: number) => (
                                <div key={index} style={{display: "flex", flexDirection: "row", border: "1px solid #EDEFF3"}}>
                                    <div style={{width: "200px", marginLeft: "10px", marginTop: "auto", marginBottom: "auto"}}>
                                        <Typography style={{fontSize: "12px"}}>{formatLocal(element.get("CreatedDatetime"))}</Typography>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "column", width: "calc(100% - 200px)"}}>
                                        <div style={{minWidth: "100px"}}><Typography style={{fontSize: "12px"}}>Row: {element.get("LogJSON").Row}</Typography></div>
                                        <div style={{minWidth: "100px"}}><Typography style={{fontSize: "12px"}}>Code: {element.get("LogJSON").Code}</Typography></div>
                                        <div style={{minWidth: "200px"}}><Typography style={{fontSize: "12px"}}>DocumentID: {element.get("LogJSON").DocumentID}</Typography></div>
                                        <div style={{minWidth: "200px"}}><Typography style={{fontSize: "12px"}}>Message: {element.get("LogJSON").Message}</Typography></div>
                                        <div style={{minWidth: "200px"}}><Typography style={{fontSize: "12px", color: element.get("LogJSON").Result ? "#FF0000" : "#00FF00"}}>Result: {element.get("LogJSON").Result}</Typography></div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : null}
                {viewOption === "System Execution Logs" ? (
                    <>
                        <div style={{display: "flex", flexDirection: "column", paddingTop: "20px", padding: "20px 20px 20px 20px", marginTop: "15px", backgroundColor: "#FFFFFF", border: "1px solid #EDEFF3", borderRadius: "20px"}}>
                            {etlJobSystemExecutionLogBuffer && etlJobSystemExecutionLogBuffer.get("LogJSON") && etlJobSystemExecutionLogBuffer.get("LogJSON").map((element: any, index: number) => (
                                <div style={{display: "flex", flexDirection: "row", border: "1px solid #EDEFF3", justifyContent: "flex-start"}}>
                                    <div style={{minWidth: "200px"}}><Typography style={{fontSize: "12px"}}>{formatLocal(moment.utc(moment.unix(element.timestamp/1000)).format(ISO_8601))}</Typography></div>
                                    <div style={{width: "calc(100%-200px)"}}><Typography style={{fontSize: "12px"}}>{element.message}</Typography></div>
                                </div>
                            ))}
                        </div>
                    </>
                ) : null}
            </div>

        </>
    )
}
